export default function emitEventWithData(action, data) {
    const ev = new CustomEvent('app-event-with-data', {
        detail: {
            action,
            data
        }
    });
    window.dispatchEvent(ev);
}
